<template>
  <Product
    :id="applyIds.productId"
    :com-type="comType"
    :info="productDetails"
    :retailIntoInfoDO="retailIntoInfoDO"
    :disabled="disabledProduct"
    @changeProduct="changeProduct"
  />
  <div class="addForm-box" v-if="showAll">
    <el-form ref="formRef" :model="formDataField" label-position="top">
      <template v-for="item in positionsList" :key="item.title">
        <SubField
          ref="SubFieldRef"
          v-if="!item.subField"
          :moduleData="item"
          :formData="formDataField"
          :originFormData="originFormData"
        />
        <SubList
          :ref="el => setRefMap(el, item)"
          v-if="item.subField === 1 && item.show"
          :moduleData="item"
          :applyIds="applyIds"
          :comType="comType"
        />
      </template>
    </el-form>
  </div>
  <Contact :id="retailIntoInfoDO?.intoId" :comType="comType" v-if="showAll" />
  <Approval
    ref="approvalRef"
    :data="{
      ...retailIntoInfoDO,
      decryptPhone: retailIntoInfoDO.decryptPhone || applyIds.phone
    }"
    :comType="comType"
    :productInfo="productDetails"
  />
</template>

<script setup lang="tsx">
import Contact from './contact.vue'
import Approval from './approval.vue'
import Product from './product.vue'
import SubField from './filed/index.vue'
import SubList from './list/index.vue'
import { getProduct, getSubTablebpm, getSubTableerp, getApproveInfo } from '@/apis/erp/income'
import { useIncomeDetail, DefaultValue, FormValue } from './useIncomeDetail'
provide('tableVisible', tableVisible)

const props = defineProps({
  applyIds: {
    type: Object,
    default: () => {}
  },
  tableCode: {
    type: String
  },
  defaultValues: {
    type: Object as PropType<DefaultValue>,
    default: () => ({})
  },
  allShow: Boolean,
  permissions: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  }
})

// 101 erp 102 bpm
const comType = computed(() => {
  return props.tableCode === 'f455ff3085cd4bd0a1f4e5e4dd7b6344' ? 101 : 102
})

const formRef = ref()

const {
  formatFieldConfig,
  positionsList,
  formDataField,
  retailIntoInfoDO,
  originFormData,
  productDetails
} = useIncomeDetail({
  defaultValues: props.defaultValues,
  showAll: props.allShow,
  permissions: props.permissions
})

const showAll = ref(false)
const disabledProduct = computed(() => {
  let arr = props.permissions['productName']
  if (!arr) return true
  if (arr.length) {
    return arr.includes('WRITE')
  }
  return false
})
const productId = ref()
// 产品改变 对应的数据也要改变
async function changeProduct(proData: Recordable) {
  productId.value = proData.id
  let apis: Fn[] = [getProduct, getApproveInfo]
  let productPosition = []
  let baseInfo: FormValue = {} as FormValue
  let formData = new FormData()
  formData.append('intoId', props.applyIds.id)
  try {
    productPosition = await apis[0]({ productId: unref(productId) })
    baseInfo = await apis[1](formData)
  } catch (e) {
    console.log(e)
  } finally {
    let api = comType.value === 101 ? getSubTableerp : getSubTablebpm
    await formatFieldConfig(productPosition, baseInfo, api, props.applyIds.id)
  }
  showAll.value = true
}

// 子表显隐
function tableVisible(item: Recordable, val: string) {
  if (item.showHideRule) {
    console.log(item, val, '子表显隐')
    let showHideRule = Object.keys(JSON.parse(item.showHideRule))

    if (showHideRule.includes(val)) {
      item.customField.renderConfig?.visibleEmitter?.emit(`showtable${item.field}`, true)
    } else {
      item.customField.renderConfig?.visibleEmitter?.emit(`showtable${item.field}`, false)
    }
  }
}

onMounted(() => {
  console.log(positionsList, 'positionsList')
})

const SubFieldRef = ref()
const approvalRef = ref()
async function handleSave() {
  const params = {
    infoDTO: {
      productId: productId.value,
      belongTenantName: retailIntoInfoDO.value.belongTenantName
    },
    baseExtendDTO: formDataField.value,
    relateExtendDTOList: [] as Recordable
  }
  // 主表校验
  let isOk = false
  try {
    isOk = await formRef.value.validate()
  } catch (e) {
    isOk = false
  }
  if (!isOk) {
    return { errorMessage: '必填项未填写或填写错误！' }
  }
  if (SubFieldRef.value) {
    const valid = SubFieldRef.value[0].validate()
    if (valid) {
      return { errorMessage: valid }
    }
  }
  // 子表校验
  let errorMessage = ''
  positionsList.value.forEach((element: Recordable) => {
    if (element.subField === 1) {
      const name = `subList_${element.tID}`
      const valid = refMap[name]?.value?.validate()
      errorMessage = errorMessage || valid
    }
  })
  if (errorMessage) {
    return { errorMessage }
  }
  // 审批校验
  const rule = await approvalRef.value.getApprovalData()
  if (rule) {
    params.infoDTO = {
      ...params.infoDTO,
      ...rule
    }
  } else {
    return { errorMessage: '必填项未填写或填写错误！' }
  }

  positionsList.value.forEach((element: Recordable) => {
    if (element.subField === 1) {
      const name = `subList_${element.tID}`
      const list = refMap[name]?.value?.getData()
      list?.forEach((v: Recordable) => {
        params.relateExtendDTOList.push(v)
      })
    }
  })
  return params
}

const refMap: Record<string, any> = {}
const setRefMap = (el: any, item: Recordable) => {
  const name = `subList_${item.tID}`
  if (el) {
    refMap[name] = ref(el)
  }
}

function getChangeList() {
  let list: Recordable = []
  if (SubFieldRef.value) {
    list = list.concat(SubFieldRef.value[0].getChangeList())
  }
  list = list.concat(approvalRef.value.getChangeList())
  positionsList.value.forEach((element: Recordable) => {
    if (element.subField === 1) {
      const name = `subList_${element.tID}`
      const sub = refMap[name]?.value.getChangeList()
      list = list.concat(sub)
    }
  })
  return list
}

defineExpose({
  handleSave,
  getChangeList
})
</script>

<style scoped lang="scss">
.addForm-box {
  margin: 16px 24px;
}
</style>
